import { useRouter } from 'next/router';
import { toast, Toast } from 'react-hot-toast';

interface CustomToastProps {
  t: Toast; // The 't' object passed by react-hot-toast
  message: string;
  type: 'success' | 'error' | 'loading';
}

export default function CustomToast({ t, message, type }: CustomToastProps) {
  const {locale} = useRouter();
  const getStyle = () => {
    switch (type) {
      case 'success':
        return {
          background: 'rgba(16, 185, 129, 0.95)',
          color: '#fff',
          border: '2px solid #059669',
          boxShadow:
            '0 20px 25px -5px rgba(16, 185, 129, 0.3), 0 10px 10px -5px rgba(16, 185, 129, 0.2)',
        };
      case 'error':
        return {
          background: 'rgba(239, 68, 68, 0.95)',
          color: '#fff',
          border: '2px solid #DC2626',
          boxShadow:
            '0 20px 25px -5px rgba(239, 68, 68, 0.3), 0 10px 10px -5px rgba(239, 68, 68, 0.2)',
        };
      case 'loading':
        return {
          background: 'rgba(59, 130, 246, 0.95)',
          color: '#fff',
          border: '2px solid #2563EB',
          boxShadow:
            '0 20px 25px -5px rgba(59, 130, 246, 0.3), 0 10px 10px -5px rgba(59, 130, 246, 0.2)',
        };
      default:
        return {};
    }
  };

  return (
    <div
      onClick={() => {
        toast.dismiss(t.id);
      }}
      style={{
        ...getStyle(),
        padding: '24px 28px',
        borderRadius: '16px',
        fontSize: '18px',
        fontWeight: '500',
        direction: 'rtl',
        animation: 'slideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        maxWidth: '500px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          toast.dismiss(t.id);
        }}
        style={{
          background: '#fff',
          border: 'none',
          borderRadius: '0.25rem',
          cursor: 'pointer',
          marginLeft: '16px',
          padding: 2,
          color: '#000'
        }}
        aria-label="Close toast"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="20"
          width="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <span className={`${locale === 'ar' ? 'text-right' : 'text-left'}`}>{message}</span>
    </div>
  );
}